import React, { ChangeEvent } from 'react';
import { Select } from 'common/components';

interface NodeConfigLeadProps {
    value: string;
    onChange: (value: string) => void;
}

export const NodeConfigLead: React.FC<NodeConfigLeadProps> = ({ value, onChange }) => {
    return (
        <div>
            <Select
                id='lead-status'
                label='Lead Status'
                value={value}
                onChange={(e: ChangeEvent<HTMLSelectElement>) => onChange(e.target.value)}
                options={[
                    { value: '', label: '--Select Status--' },
                    { value: 'New', label: 'New' },
                    { value: 'In Progress', label: 'In Progress' },
                    { value: 'Nurturing', label: 'Nurturing' },
                    { value: 'Qualified', label: 'Qualified' },
                ]}
            />
        </div>
    );
};
